import { Injectable } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class FilterService {
  // Private Fields
  private isFilterChanged: boolean;

  // Contructors
  constructor() {
    this.isFilterChanged = false;
  }

  // Properties
  public get isEdited(): boolean {
    return this.isFilterChanged;
  }

  //Methods
  public Edit()
  {
   this.isFilterChanged = true;
  }

  public Clear() {
    this.isFilterChanged = false;
  }
}
